import { Button } from "antd";
import styles from "./mobile.module.scss";
import { useEffect, useState } from "react";
import { useLayouts } from "../layouts";
import MenuBar, { MenuGlobal } from "../menu/MenuBar";

const MobileView = () => {
  const { checkLoginUser, refreshUser } = useLayouts();
  const [isLogin, setIsLogin] = useState(false);
  const [users, setUser] = useState({});

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const intial = async () => {
      const res = await checkLoginUser();
      setIsLogin(res);

      const refresh = await refreshUser();
      setUser(refresh);
    };
    intial();
  }, []);

  return (
    <>
      <div className={`${styles.holder_heading}  ${isOpen && styles.open}`}>
        <div className={styles.row_heading}>
          <div className={styles.hamburger_holder}>
            <button className={`${styles.hamburger} `} onClick={() => setIsOpen((prev) => !prev)} type="button">
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          <div className={styles.logo}>
            <a href="https://www.aptel.ir">
              <img src={process.env.PUBLIC_URL + process.env.REACT_APP_ROOT_PATH_FILE + "/assets/images/logo.png"} alt="" />
            </a>
          </div>
          <div className={styles.action}>
            <div className={`holder-button ${styles.hold}`}>
              <Button className={`btn-aptel ${styles.button}`}>آپتل من</Button>
            </div>
          </div>
        </div>
        <div className={`${styles.hold_side} ${isOpen && styles.open}`}>
          <div className={styles.menuside}>
            <span className={styles.close} onClick={() => setIsOpen((prev) => !prev)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M1.12538 0L0 1.12538L6.87462 8L0 14.8746L1.12538 16L8 9.12538L14.8746 16L16 14.8746L9.12538 8L16 1.12538L14.8746 0L8 6.87462L1.12538 0Z"
                  fill="black"
                />
              </svg>
            </span>
            {isLogin ? (
              <>
                <MenuBar users={users} />
              </>
            ) : (
              <>
                <MenuGlobal />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileView;
